import { type MouseEvent } from 'react';
import styled from 'styled-components';

import IconCopyOutlineSvg from '../../../assets/icons/icon-copy-outline.svg?react';
import { BaseButton } from '../../../shared/ui';

type VerifyPasteCodeActionProps = {
  ariaLabel: string;
  isDisabled: boolean;
  onPasteCode: () => Promise<void>;
};

const PasteCodeAction = styled(BaseButton).attrs({
  'data-ui': 'auth-verify-paste-code-action',
})`
  width: ${({ theme }) => theme.scale.px(24)};
  height: ${({ theme }) => theme.scale.px(24)};
  display: grid;
  place-items: center;
`;

const PasteCodeIcon = styled(IconCopyOutlineSvg).attrs({
  'aria-hidden': true,
  focusable: 'false',
})`
  width: ${({ theme }) => theme.scale.px(15)};
  height: ${({ theme }) => theme.scale.px(18)};
  display: block;
  color: ${({ theme }) => theme.colors.text.primary};
  opacity: 0.5;

  & rect {
    stroke: currentColor;
  }
`;

export function VerifyPasteCodeAction({
  ariaLabel,
  isDisabled,
  onPasteCode,
}: VerifyPasteCodeActionProps) {
  const handlePasteCode = (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    event.stopPropagation();
    void onPasteCode();
  };

  return (
    <PasteCodeAction
      aria-label={ariaLabel}
      disabled={isDisabled}
      type="button"
      onClick={handlePasteCode}
    >
      <PasteCodeIcon />
    </PasteCodeAction>
  );
}
